import React from 'react';

export interface ActivitiesProps {}

const Activities: React.FC<ActivitiesProps> = (props) => {
    return (
        <div className="site-page-content">
            <h1>Leadership</h1>
            <h3>& Writing</h3>
            <br />
            <div className="text-block">
                <h2>Leadership</h2>
                <br />
                <ul>
                    <li>
                        <p>
                            Vice-President, organising committee of Tempest,
                            Miranda House's annual college festival (2015).
                        </p>
                    </li>
                    <li>
                        <p>Captain, Miranda House basketball team.</p>
                    </li>
                    <li>
                        <p>
                            Captained the KV Bengaluru Region U-19 team to gold
                            at the KV National Games, New Delhi (2011).
                        </p>
                    </li>
                </ul>
            </div>
            <div className="text-block">
                <h2>Writing & Performance</h2>
                <br />
                <p>I write poetry and fiction in Hindi and English.</p>
                <br />
                <ul>
                    <li>
                        <p>
                            <b>Play:</b> "New Life"
                        </p>
                    </li>
                    <li>
                        <p>
                            <b>Short stories:</b> "Road to Hope" and "Unknown
                            Girl with Known Face"
                        </p>
                    </li>
                </ul>
                <br />
                <p>
                    I have performed on Delhi's open-mic circuit and with
                    Anukriti, Miranda House's dramatics society.
                </p>
            </div>
        </div>
    );
};

export default Activities;
